import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultSchemesCategoryData, getSchemesCategoryById, updateSchemesCategory, createSchemesCategory } from '@/api/schemes-categories';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getQuery } from '@/utils';
import { getProducts } from '@/api/products';
import { getSchemes } from '@/api/schemes';
import { getDealersRoles } from '@/api/dealers-roles';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.image = [];
    this.icon = [];
    this.schemes = [];
    this.dealersRoles = [];
    this.isReadOnly = false;
    this.formData = Object.assign({}, defaultSchemesCategoryData);
    this.products = [];
    this.selectedProducts = [];
    this.selectedDealersRole = '';
    this.loading = false;
    this.rules = {
      name: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  async activated() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      await this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultSchemesCategoryData);
    }
    await this.getSchemes();
    await this.getDealersRoles();
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getSchemesCategoryById(id);
      this.formData = data;
      // check if products are saved
      if (this.formData.product && this.formData.product.length) {
        // Set selected products
        this.selectedProducts = this.formData.product.map(product => product.id);
        const productsList = [];
        this.formData.product.forEach(value => {
          productsList.push({
            id: value.id,
            name: value.name
          });
        });
        this.products = productsList;
      }
      if (this.formData.dealersRole && this.formData.dealersRole.length) {
        this.selectedDealersRole = this.formData.dealersRole.map(dealersRole => dealersRole.id);
        const dealersRoleList = [];
        this.formData.dealersRole.forEach(value => {
          dealersRoleList.push({
            id: value.id,
            name: value.name
          });
        });
        this.dealersRoles = dealersRoleList;
      }
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  async getProducts(query = '') {
    try {
      if (query.length > 2) {
        this.products = await getProducts(getQuery({
          limit: 10,
          enabled: true,
          name: query,
          isGiftItem: false,
          filter: {
            enabled: 'eq',
            name: '$contL',
            isGiftItem: 'eq'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        await updateSchemesCategory(this.formData.id, this.formData);
      } else {
        await createSchemesCategory(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Schemes Category saved',
        type: 'success',
        duration: 2000
      });
      router.push('/schemes-categories/list');
    } catch (err) {
      this.loading = false;
    }
  }
  handleProductChange(product) {
    // assign selected products to form data
    this.formData.product = [];
    // loop over selected products and push to form data
    this.selectedProducts.forEach(productId => {
      this.formData.product.push({
        id: productId
      });
    });
  }
  handleDealersRoleChange(dealersRoleId) {
    if (this.formData.dealersRole.length > 0) {
      this.formData.dealersRole.pop();
      this.formData.dealersRole.push({
        id: this.selectedDealersRole
      });
    } else {
      this.formData.dealersRole.push({
        id: this.selectedDealersRole
      });
    }
  }
  async getSchemes() {
    this.schemes = await getSchemes(getQuery({
      id: this.formData.schemeId || undefined,
      enabled: true,
      filter: {
        id: 'eq',
        enabled: 'eq'
      }
    }));
  }
  async getDealersRoles() {
    this.dealersRoles = await getDealersRoles(getQuery({
      id: this.formData.dealersRoleId || undefined,
      enabled: true,
      filter: {
        id: 'eq',
        enabled: 'eq'
      }
    }));
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'SchemesCategoriesDetail',
  components: {}
})], default_1);
export default default_1;